import { render, staticRenderFns } from "./AtomAvatarEdition.vue?vue&type=template&id=93a495ea&"
import script from "./AtomAvatarEdition.vue?vue&type=script&lang=js&"
export * from "./AtomAvatarEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports